import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageHelperService } from '../helpers/page-helper.service';
import { BlackboxPositionDto, CustomerLocationDto, JourneyItemDto, LocationDetailsService, MovementService } from 'src/shared/service-proxies/service-proxies';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import * as L from 'leaflet';
import { PagingModel } from '../widgets/models/paging-model';
import { LocationClassNameHelper } from '../enums/LocationTypeNames';
import { GeoHelper } from '../helpers/geo';
import { GoogleSnappedRoadItem, GoogleSnappedRoadResult, RoadsService } from '../services/roads.service';
import { DateTimeHelper } from '../helpers/datetime';
import { CustomerSettings } from '../services/customer-settings-service';

export interface JobItemModel extends CustomerLocationDto {
  selected?: string;
}

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationsComponent extends PagebaseComponent implements OnInit {
  
  
  @ViewChild('mapdiv')
  mapDiv: ElementRef;
  locationDataLoaded: boolean = false;  
  locations: CustomerLocationDto[];
  selectedLocationId: string = "";
  
  // Private variables
  private movementId: string;
  private firstInit: boolean = true;
  
  // Map
  private map;
  private mapLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=AIzaSyBbtdwYOxBg-pnwcNSKmIw0O86uBHStozI', {
      maxZoom: 18,
      minZoom: 3,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
  });
  private drawLayer = L.layerGroup();

  constructor(
    private browserLocation: Location,
    private router: Router,
    pageHelperService: PageHelperService,
    private locationDetailsService: LocationDetailsService,
    applicationStatusService: ApplicationStatusService,
    private route: ActivatedRoute,
    private customerSettings: CustomerSettings) { 
      super(pageHelperService, applicationStatusService, customerSettings, "Locations");
    }

  ngOnInit() {
    this.route.params.subscribe(({ id }) => {
      if (!this.firstInit) {
        this.locationDataLoaded = false;
        this.getData(false);
      }
    });
    this.firstInit = false;
  }  
  
  ngOnDestroy(): void {
    if (this.map ){
      this.map.eachLayer(function(layer){
          layer.remove();
      });
      this.map.remove();
      this.map = null;
      this.mapDiv.nativeElement.innerHTML = "";
    }
  }

  getData(companyChange: boolean) {
    this.locationDetailsService.getLocations(this.pageHelperService.selectedCompanyId).subscribe(data => 
    {
      this.locations = data;
      this.initMap();
    });
  }

  private initMap(): void {
    var allLatLons = [];
    this.locations.forEach(location => {
      allLatLons.push({ lat: location.latitude, lon: location.longitude })
    });
    
    var centre = GeoHelper.GetCenterFromPositions(allLatLons);
    
    if (!this.map) {
      let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
      this.map = L.map('map', {
        center: [ centre.lat, centre.lon ],
        zoom: zoom,
        scrollWheelZoom: false
      });

      this.mapLayer.addTo(this.map);
      this.drawLayer.addTo(this.map);
      setTimeout(() => {
        this.map.invalidateSize(true);
      }, 1)
    } else {
      this.map.flyTo(new L.LatLng(centre.lat, centre.lon), 15, {
        animate: true,
        duration: 1.5
      });
    }

    this.drawLocations('')
  }

  drawLocations(selectedLocationId) {
    // Clear  and re add draw layer
    var allLatLons = [];
    this.map.removeLayer(this.drawLayer);
    this.drawLayer = L.layerGroup();
    this.drawLayer.addTo(this.map);
    
    this.locations.forEach(location => {
      if (selectedLocationId == "" || selectedLocationId == location.id) {
        this.addLocationPin(location.id, location.locationType, location.displayName, location.latitude, location.longitude);
        allLatLons.push({ lat: location.latitude, lon: location.longitude })
      }
    });

    var centre = GeoHelper.GetCenterFromPositions(allLatLons);
    let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
    zoom = allLatLons.length == 1 ? 12 : zoom;
    this.map.flyTo(new L.LatLng(centre.lat, centre.lon), zoom, {
      animate: true,
      duration: 1.5
    });
  }

  onLocationSelected(item) {
    if (item == null) {
      this.selectedLocationId = "";
    } else {
      this.selectedLocationId = item.id;
    }

    this.drawLocations(item == null ? '' : item.id)
  }

  reset() {

  }

  addLocationPin(locationId, locationTypeName, locationName, locationLatitude, locationLongitude) {
    var className = locationTypeName == null ? "vehicle" : LocationClassNameHelper.getLocationClassName(locationTypeName);
    let icon = L.divIcon({
      className: 'custom-div-icon',
      html: "<div class='marker-pin " + className + "'></div><i class='material-icons'>" + (locationTypeName == null ? "local_shipping" : "home") + "</i>",
      iconSize: [30, 42],
      iconAnchor: [15, 36]
    });
    
    let popup = '<p>' + locationName + '</p>';
    var marker = L.marker([locationLatitude, locationLongitude], { icon: icon }).addTo(this.drawLayer);
    var showTip = function() {
      this.unbindTooltip();
      if(!this.isPopupOpen()) this.bindPopup(popup, { minWidth: 280}).openPopup();
    }
    
    var hideTip = function() {
      this.unbindTooltip();
      if(this.isPopupOpen()) this.closePopup();
    }
    
    var router = this.router;
    var goToRoute = function() {
      router.navigate([`/location/${locationId}`]);
    }

    marker.on('mouseover', showTip);
    marker.on('mouseout', hideTip);
    marker.on('click', goToRoute);
  }
}

